<template>
  <el-drawer
  title="Filtres"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form label-position="top">
      <el-form-item>
        <el-button @click="resetProductFilters" size="mini">Remettre les filtres d'origine</el-button>
      </el-form-item>
      <el-collapse v-model="activeName" >
      <el-collapse-item title="Général" name="1">
        <el-form-item>
          <el-radio-group v-model="productActive">
            <el-radio-button label="1">Actif</el-radio-button>
            <el-radio-button label="0">Inactif</el-radio-button>
            <el-radio-button label="2">Tous</el-radio-button>
          </el-radio-group>
        </el-switch>
      </el-form-item>
        <el-form-item>
          <el-radio-group v-model="productPublished">
            <el-radio-button label="1">Publié</el-radio-button>
            <el-radio-button label="0">Non publié</el-radio-button>
            <el-radio-button label="2">Tous</el-radio-button>
          </el-radio-group>
        </el-switch>
      </el-form-item>
      </el-collapse-item>
        <el-collapse-item title="Étiquettes" name="2">
          <el-form-item>
             <el-checkbox-group  v-model="checkedTags" >
               <el-row v-for="tag in listTags" :key="tag.id">
                 <el-col>
                   <el-checkbox :label="tag.id" style="margin-left:0px;">{{tag.code}}</el-checkbox>
                 </el-col>
               </el-row>
             </el-checkbox-group>
           </el-form-item>
        </el-collapse-item>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import productAPI from '@/services/API/product'
import moment from 'moment';

export default {
  name: 'product-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : ['1'],
    };
  },components: {

  },
  watch : {

  },
	methods: {
    emitFiltersChange() {
      this.$emit('filtersChange', {
        activeFilters: this.activeFilters,
        filters: {
          tags: this.productFilters.checkedTags,
          productsAvailabilityInd: this.productsAvailabilityInd,
          productPublished: this.productPublished,
          productPublished: this.productPublished,
        }
      }) ;
    },
    open(){
      this.fetchTags();
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('products',['fetchTags', 'setProductPublishedInd', 'resetProductFilters', 'setCheckedProductsTags', 'setActiveFilter']),
	},
  watch: {
    // whenever question changes, this function will run
    checkedTags() {
        this.emitFiltersChange();
    },
    productPublished () {
      this.emitFiltersChange();
    },

  },
	computed: {
    activeFilters () {
      let nbActive = 0;
      if(this.productsAvailabilityInd != null) nbActive++;
      if(this.productPublished != 2) nbActive++;

      if(this.productFilters.checkedTags.length>0) nbActive += this.productFilters.checkedTags.length;
      return nbActive;
    },
		checkedTags : {
			set(val){
        this.setCheckedProductsTags(val);
      },
			get(){return this.getFilterCheckedTags}
		},
    productPublished : {
      set(productPublished){
        this.setProductPublishedInd(productPublished);
      },
			get(){return this.getFilterPublishedInd }
    },
    productActive : {
      set(ind){
        this.setActiveFilter(ind);
      },
      get(){return this.getFilterProductActive }
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('products',['listTags', 'productFilters']),
    ...mapGetters('products', ['getFilterPublishedInd', 'getFilterCheckedTags', 'getFilterProductActive'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
